export * from './routes'

export const APP_NAME = 'EventPady+'
export const APP_VERSION = '1.0.0'

/** TanStack Query stale times — used when a component needs a non-default value */
export const STALE_TIME = {
  SHORT: 1000 * 30,       // 30 s — high-frequency data (compliance events, SMS status)
  MEDIUM: 1000 * 60,      // 60 s — default (matches queryClient.ts)
  LONG: 1000 * 60 * 10,   // 10 min — rarely changes (org settings, subscription plan)
} as const

/** Pagination defaults */
export const PAGE_SIZE = 25

/**
 * localStorage keys — NEVER store auth tokens here.
 * Tokens live in the in-memory tokenStore (services/api/client.ts).
 */
export const STORAGE_KEYS = {
  THEME: 'ep_theme',
  SIDEBAR_COLLAPSED: 'ep_sidebar_collapsed',
} as const
